import script from "./InspectionReport.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionReport.vue?vue&type=script&setup=true&lang=js"

import "./InspectionReport.vue?vue&type=style&index=0&id=7f0b7adc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f0b7adc"]])

export default __exports__